export { ARROW_SIZES } from "@frontend/components/atoms/DatePicker/constants";

export const YEAR_PICKER_TAG_NAME = "year-picker" as const;

export const YEAR_PICKER_LAYOUTS = ["default", "text"] as const;

export const YEARS_PER_ROW = 3;

/** A decade, with the year before and the year after to fill four rows. */
export const YEARS_PER_VIEW = 12;
